import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { MODEL_FAMILY_TYPES } from '@/types';

interface VllmModelFamilyFieldProps {
  value: MODEL_FAMILY_TYPES | null;
  setValue: (value: MODEL_FAMILY_TYPES | null) => void;
}

function VllmModelFamilyField({
  value,
  setValue,
}: VllmModelFamilyFieldProps): React.JSX.Element {
  return (
    <FormControl fullWidth>
      <InputLabel id='vllm-model-family-label'>vLLM Model Family</InputLabel>
      <Select
        labelId='vllm-model-family-label'
        label='vLLM Model Family'
        value={value ?? ''}
        onChange={(e) => {
          const v = e.target.value;
          setValue(v ? (v as MODEL_FAMILY_TYPES) : null);
        }}
      >
        <MenuItem value=''>
          <em>None</em>
        </MenuItem>
        {Object.values(MODEL_FAMILY_TYPES).map((model_family) => (
          <MenuItem key={model_family} value={model_family}>
            {model_family}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default VllmModelFamilyField;

